module.exports = __webpack_public_path__ + "static/founder-9d977f06d34333d4774c6746c04d6cda.jpg";